/* Slider controls for the media grid's mobile card scroller.
 *
 * Renders as a rule, an "01/03" counter and prev/next arrows, matching the comp. Tracks the
 * card in view and disables the arrows at each end. The section only renders this element in
 * swipe mode, so there is nothing to do on layouts that stack.
 */

if (!customElements.get('vp-grid-counter')) {
  customElements.define(
    'vp-grid-counter',
    class extends HTMLElement {
      connectedCallback() {
        // the <script> tag sits between us and the track, so look it up by class
        this.track = this.closest('[class*="vp-media-grid--"]')?.querySelector('.vp-media-grid__container');
        this.current = this.querySelector('[data-current]');
        this.total = this.querySelector('[data-total]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || !this.current) return;

        this.count = this.track.children.length;
        if (this.total) this.total.textContent = String(this.count).padStart(2, '0');

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.index = this.indexFromScroll();
            this.current.textContent = String(this.index + 1).padStart(2, '0');
            if (this.prev) this.prev.disabled = this.index <= 0;
            if (this.next) this.next.disabled = this.index >= this.count - 1;
            this.ticking = false;
          });
        };

        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        this.onScroll();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
      }

      step() {
        const first = this.track.firstElementChild;
        if (!first) return 1;
        const second = first.nextElementSibling;
        // card width plus the grid gap, taken from the live layout
        return second
          ? second.getBoundingClientRect().left - first.getBoundingClientRect().left
          : first.getBoundingClientRect().width;
      }

      indexFromScroll() {
        return Math.min(this.count - 1, Math.max(0, Math.round(this.track.scrollLeft / this.step())));
      }

      /** @param {number} delta */
      go(delta) {
        const from = this.pending ?? this.indexFromScroll();
        const target = Math.min(this.count - 1, Math.max(0, from + delta));
        this.pending = target;
        const card = this.track.children[target];
        if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        else this.track.scrollTo({ left: target * this.step(), behavior: 'smooth' });
        clearTimeout(this.settle);
        this.settle = setTimeout(() => { this.pending = null; }, 500);
      }
    }
  );
}
